import type { FormEditor } from 'library/types/events';

const defaultEditorValues: FormEditor = {
  address: {
    city: '',
    country: '',
    description: '',
    house: '',
    office: '',
    street: '',
    unit: '',
  },
  cost: 0,
  costs: [],
  contacts: [],
  prepayment_cost: 0,
  prepayment_cost_method: 'O',
  description: '',
  event_block: [],
  event_coach: [
    {
      description: '',
      first_name: '',
      last_name: '',
      photo: '',
      second_name: '',
    },
  ],
  event_image: '',
  event_type: '',
  external_service: null,
  language: '',
  mode: 'O',
  module: 0,
  places: 0,
  refusal: null,
  tags: [],
  time_from: null,
  time_to: null,
  timetable: [
    {
      time_from: new Date(),
      time_from_day: new Date(),
      time_to: new Date(),
    },
  ],
  title: '',
  video_file: '',
  video_type: 'B',
  youtube_url: '',
};

export default defaultEditorValues;
